// extracted by mini-css-extract-plugin
export var artists_list = "ArtistsList-module--artists_list--vmx49";